// @core/api/endpoints/workflow/debug_step.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  DebugSessionResponse,
  DebugStepRequest,
} from '../../../types/workflow';

const BASE_PATH = '/workflow';

/**
 * Debug step
 * Advances the debug execution by one step (step over, step into, continue, or pause).
 */
export async function DebugStep(
  session_id: string,
  data: DebugStepRequest,
  options?: RequestOptions
): Promise<DebugSessionResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/workflows/debug/:session_id/step`;
  requestPath = requestPath.replace(':session_id', encodeURIComponent(session_id));
  const requestOptions = options;
  return client.post<DebugSessionResponse>(requestPath, data, requestOptions);
}
